// import React, { useState, useEffect } from "react";
// import { Box, Typography, TextField, Button, MenuItem, Select, FormControl, InputLabel, Paper, Divider, Grid, CircularProgress } from '@mui/material';
// import { styled } from '@mui/system';

// const StyledPaper = styled(Paper)(({ theme }) => ({
//   padding: theme.spacing(3),
//   margin: theme.spacing(2, 0),
//   borderRadius: theme.shape.borderRadius * 2,
//   boxShadow: theme.shadows[3],
// }));

// const StyledButton = styled(Button)(({ theme }) => ({
//   marginTop: theme.spacing(2),
//   padding: theme.spacing(1.5),
//   fontWeight: 'bold',
//   fontSize: '1rem',
// }));

// const PayrollPage = () => {
//   const [earnings, setEarnings] = useState([]);
//   const [deductions, setDeductions] = useState([]);
//   const [employees, setEmployees] = useState([]);
//   const [selectedEmployee, setSelectedEmployee] = useState("");
//   const [selectedDate, setSelectedDate] = useState("");
//   const [earningValues, setEarningValues] = useState({});
//   const [deductionValues, setDeductionValues] = useState({});
//   const [existingPayroll, setExistingPayroll] = useState(null);
//   const [isPreview, setIsPreview] = useState(false);
//   const [isLoading, setIsLoading] = useState(false);
//   const [defaultCTCEarnings, setDefaultCTCEarnings] = useState([]);
//   const [defaultCTCDeductions, setDefaultCTCDeductions] = useState([]);

//   useEffect(() => {
//     fetchEmployees();
//     fetchCTCDetails();
//   }, []);

//   useEffect(() => {
//     if (selectedEmployee && selectedDate) {
//       checkExistingPayroll();
//     } else {
//       setExistingPayroll(null);
//       setEarnings(defaultCTCEarnings);
//       setDeductions(defaultCTCDeductions);
//       setEarningValues({});
//       setDeductionValues({});
//     }
//   }, [selectedEmployee, selectedDate]);

//   const fetchEmployees = async () => {
//     try {
//       const response = await fetch(`${process.env.REACT_APP_BACKEND_URL_HRM}/get-employees`);
//       const data = await response.json();
//       if (response.ok) {
//         setEmployees(data.employees);
//       } else {
//         alert(data.error);
//       }
//     } catch (error) {
//       console.error("Error fetching employees:", error);
//       alert("Failed to load employees.");
//     }
//   };

//   const checkExistingPayroll = async () => {
//     try {
//       setIsLoading(true);
//       const response = await fetch(`${process.env.REACT_APP_BACKEND_URL_HRM}/get-payroll`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({
//           email_id: selectedEmployee,
//           date: selectedDate,
//         }),
//       });

//       const data = await response.json();
//       if (response.ok && data.payroll_data) {
//         setExistingPayroll(data.payroll_data);
//         const payrollEarnings = Object.keys(data.payroll_data.earnings || {});
//         const payrollDeductions = Object.keys(data.payroll_data.deductions || {});
        
//         setEarnings(payrollEarnings);
//         setDeductions(payrollDeductions);
//         setEarningValues(data.payroll_data.earnings || {});
//         setDeductionValues(data.payroll_data.deductions || {});
//       } else {
//         setExistingPayroll(null);
//         setEarnings(defaultCTCEarnings);
//         setDeductions(defaultCTCDeductions);
//         setEarningValues({});
//         setDeductionValues({});
//       }
//     } catch (error) {
//       console.error("Error checking existing payroll:", error);
//       setExistingPayroll(null);
//       setEarnings(defaultCTCEarnings);
//       setDeductions(defaultCTCDeductions);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const fetchCTCDetails = async () => {
//     try {
//       const response = await fetch(`${process.env.REACT_APP_BACKEND_URL_HRM}/get_ctc`);
//       const data = await response.json();
//       if (response.ok) {
//         setEarnings(data.earnings || []);
//         setDeductions(data.deductions || []);
//         setDefaultCTCEarnings(data.earnings || []);
//         setDefaultCTCDeductions(data.deductions || []);
//       } else {
//         alert(data.error);
//       }
//     } catch (error) {
//       console.error("Error fetching CTC details:", error);
//       alert("Failed to load CTC details.");
//     }
//   };

//   const handleEarningChange = (field, value) => {
//     setEarningValues((prev) => ({ ...prev, [field]: Number(value) }));
//   };

//   const handleDeductionChange = (field, value) => {
//     setDeductionValues((prev) => ({ ...prev, [field]: Number(value) }));
//   };

//   const handlePreview = async () => {
//     if (!selectedEmployee || !selectedDate) {
//       alert("Please select an employee and date.");
//       return;
//     }

//     const payload = {
//       email_id: selectedEmployee,
//       date: selectedDate,
//       earnings: earningValues,
//       deductions: deductionValues,
//     };

//     try {
//       setIsLoading(true);
//       const response = await fetch(`${process.env.REACT_APP_BACKEND_URL_HRM}/preview-payroll`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify(payload),
//       });

//       const data = await response.json();
//       if (response.ok) {
//         setExistingPayroll(data);
//         setIsPreview(true);
//       } else {
//         alert("Error: " + data.error);
//       }
//     } catch (error) {
//       console.error("Error previewing payroll:", error);
//       alert("Failed to preview payroll.");
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleSubmit = async () => {
//     if (!selectedEmployee || !selectedDate) {
//       alert("Please select an employee and date.");
//       return;
//     }

//     const payload = {
//       email_id: selectedEmployee,
//       selected_month: selectedDate,
//       earnings: earningValues,
//       deductions: deductionValues,
//       total_earnings: existingPayroll?.total_earnings || 0,
//       total_deductions: existingPayroll?.total_deductions || 0,
//       total_salary: existingPayroll?.total_salary || 0,
//       leave_summary: existingPayroll?.leave_summary || {},
//       total_leave_days: existingPayroll?.total_leave_days || 0,
//       actual_emergency_leave: existingPayroll?.actual_emergency_leave || 0,
//       actual_planned_leave: existingPayroll?.actual_planned_leave || 0,
//       subtracted_los_emergency_leave: existingPayroll?.subtracted_los_emergency_leave || 0,
//       subtracted_los_planned_leave: existingPayroll?.subtracted_los_planned_leave || 0,
//       one_day_salary: existingPayroll?.one_day_salary || 0,
//       LOSP: existingPayroll?.LOSP || 0,
//       LOSE: existingPayroll?.LOSE || 0,
//       total_los: existingPayroll?.total_los || 0,
//       LOP_DAYS: existingPayroll?.LOP_DAYS || 0,
//       actual_working_days: existingPayroll?.actual_working_days || 0,
//       num_days: existingPayroll?.num_days || 0, 
//     };

//     try {
//       setIsLoading(true);
//       const response = await fetch(`${process.env.REACT_APP_BACKEND_URL_HRM}/store-payroll`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify(payload),
//       });

//       const data = await response.json();
//       if (response.ok) {
//         alert("Payroll data saved successfully!");
//         setIsPreview(false);
//         checkExistingPayroll();
//       } else {
//         alert("Error: " + data.error);
//       }
//     } catch (error) {
//       console.error("Error submitting payroll:", error);
//       alert("Failed to submit payroll.");
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const renderPayrollDetails = () => {
//     if (!existingPayroll) return null;

//     return (
//       <StyledPaper elevation={3}  style={{backgroundColor:"white", color:"black"}}>
//         <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', color: 'primary.main' }}>
//           Payroll Details
//         </Typography>
//         <Divider sx={{ my: 2 }} />
        
//         <Grid container spacing={3}>
//           <Grid item xs={12} md={6}>
//             <Typography variant="body1"><strong>Number of Days Paid:</strong> {existingPayroll.actual_working_days}</Typography>
//             <Typography variant="body1"><strong>Total days in month:</strong> {existingPayroll.num_days}</Typography>
//             <Typography variant="body1"><strong>LOP Days:</strong> {existingPayroll.LOP_DAYS}</Typography>
//             <Typography variant="body1"><strong>Total Leaves Taken:</strong> {existingPayroll.total_leave_days}</Typography>
//             <Typography variant="body1"><strong>Emergency Leaves Taken:</strong> {existingPayroll.leave_summary.EMERGENCY}</Typography>
//             <Typography variant="body1"><strong>Planned Leaves Taken:</strong> {existingPayroll.leave_summary.PLANNED}</Typography>
//           </Grid>
//           <Grid item xs={12} md={6}>
//             <Typography variant="body1"><strong>Leave Opening (Emergency):</strong> {existingPayroll.actual_emergency_leave}</Typography>
//             <Typography variant="body1"><strong>Leave Opening (Planned):</strong> {existingPayroll.actual_planned_leave}</Typography>
//             <Typography variant="body1"><strong>Leave Closing (Emergency):</strong> {existingPayroll.subtracted_los_emergency_leave}</Typography>
//             <Typography variant="body1"><strong>Leave Closing (Planned):</strong> {existingPayroll.subtracted_los_planned_leave}</Typography>
//           </Grid>
//         </Grid>
        
//         <Box sx={{ mt: 3, p: 2, backgroundColor: '#f5f5f5', borderRadius: 1 }}>
//           <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
//             Net Salary: ₹{existingPayroll.total_salary}
//           </Typography>
//         </Box>
//       </StyledPaper>
//     );
//   };

//   const renderPayrollForm = () => {
//     if (isPreview && existingPayroll) {
//       return (
//         <StyledPaper elevation={3}  style={{backgroundColor:"white" , color:"black" }}>
//           <Typography variant="h5" align="center" gutterBottom sx={{ fontWeight: 'bold', color: 'primary.main' }}>
//             Payroll Preview
//           </Typography>
          
//           {renderPayrollDetails()}

//           <Grid container spacing={3} sx={{ mt: 2 }}>
//             <Grid item xs={12} md={6}>
//               <Typography variant="h6" gutterBottom>Earnings</Typography>
//               {Object.entries(existingPayroll.earnings || {}).map(([key, value]) => (
//                 <Box key={key} display="flex" justifyContent="space-between" mb={1}>
//                   <Typography>{key}:</Typography>
//                   <Typography>₹{value}</Typography>
//                 </Box>
//               ))}
//               <Divider sx={{ my: 1 }} />
//               <Box display="flex" justifyContent="space-between" sx={{ fontWeight: 'bold' }}>
//                 <Typography>Total Earnings:</Typography>
//                 <Typography>₹{existingPayroll.total_earnings}</Typography>
//               </Box>
//             </Grid>

//             <Grid item xs={12} md={6}>
//               <Typography variant="h6" gutterBottom>Deductions</Typography>
//               {Object.entries(existingPayroll.deductions || {}).map(([key, value]) => (
//                 <Box key={key} display="flex" justifyContent="space-between" mb={1}>
//                   <Typography>{key}:</Typography>
//                   <Typography>₹{value}</Typography>
//                 </Box>
//               ))}
//               <Divider sx={{ my: 1 }} />
//               <Box display="flex" justifyContent="space-between" sx={{ fontWeight: 'bold' }}>
//                 <Typography>Total Deductions:</Typography>
//                 <Typography>₹{existingPayroll.total_deductions}</Typography>
//               </Box>
//             </Grid>
//           </Grid>

//           <Box display="flex" justifyContent="space-between" mt={4}>
//             <Button
//               onClick={() => setIsPreview(false)}
//               variant="outlined"
//               color="secondary"
//               sx={{ width: '48%' }}
//             >
//               Cancel
//             </Button>
//             <Button
//               onClick={handleSubmit}
//               variant="contained"
//               color="primary"
//               sx={{ width: '48%' }}
//               disabled={isLoading}
//             >
//               {isLoading ? <CircularProgress size={24} /> : 'Generate Payslip'}
//             </Button>
//           </Box>
//         </StyledPaper>
//       );
//     }

//     return (
//       <>
//         {existingPayroll && renderPayrollDetails()}

//         <StyledPaper elevation={3} style={{ backgroundColor: "white", color: "black", padding: "16px", borderRadius: "8px" }}>
//           <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', color: "black" }}>
//             Earnings
//           </Typography>
//           {earnings.map((field, index) => (
//             <TextField
//               key={index}
//               label={field}
//               type="number"
//               variant="outlined"
//               fullWidth
//               margin="normal"
//               value={earningValues[field] || ""}
//               onChange={(e) => handleEarningChange(field, e.target.value)}
//               InputProps={{
//                 startAdornment: <Typography  sx={{ mr: 1, color: "black" }}>₹</Typography>,
//                 style: { backgroundColor: "white", color: "black", borderRadius: "4px" }
//               }}

//               InputLabelProps={{
//                 style: { color: "red" } // Light gray label for better contrast
//               }}

//               sx={{
//                 "& .MuiOutlinedInput-root": {
//                   "& fieldset": { borderColor: "#555" }, // Border color
//                   "&:hover fieldset": { borderColor: "#777" }, // Hover effect
//                   "&.Mui-focused fieldset": { borderColor: "#ffffff" }, // Focus color
//                 },
//               }}
        
        
//             />
//           ))}
//         </StyledPaper>

//         <StyledPaper elevation={3} style={{ backgroundColor: "white", color: "black", padding: "16px", borderRadius: "8px" }}>
//           <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', color: "black" }}>
//             Deductions
//           </Typography>
//           {deductions
//           .filter(field => isPreview || field !== "LOP")
//             .map((field, index) => (
//               <TextField
//                 key={index}
//                 label={field}
//                 type="number"
//                 variant="outlined"
//                 fullWidth
//                 margin="normal"
//                 value={deductionValues[field] || ""}
//                 onChange={(e) => handleDeductionChange(field, e.target.value)}
//                 InputProps={{
//                   startAdornment: <Typography  sx={{ mr: 1, color: "black" }}>₹</Typography>,
//                   style: { backgroundColor: "white", color: "black", borderRadius: "4px" }
//                 }}
  
//                 InputLabelProps={{
//                   style: { color: "red" } // Light gray label for better contrast
//                 }}
  
//                 sx={{
//                   "& .MuiOutlinedInput-root": {
//                     "& fieldset": { borderColor: "#555" }, // Border color
//                     "&:hover fieldset": { borderColor: "#777" }, // Hover effect
//                     "&.Mui-focused fieldset": { borderColor: "#ffffff" }, // Focus color
//                   },
//                 }}

//               />
//             ))}
//         </StyledPaper>

//         <StyledButton
//           variant="contained"
//           color="primary"
//           fullWidth
//           onClick={handlePreview}
//           disabled={isLoading || !selectedEmployee || !selectedDate}
//           elevation={3} style={{ backgroundColor: "white", color: "black", padding: "16px", borderRadius: "8px" }}
//         >
//           {isLoading ? <CircularProgress size={24} color="inherit" /> : 'Preview Payslip'}
//         </StyledButton>
//       </>
//     );
//   };

//   return (
//     <Box sx={{ maxWidth: 900, mx: 'auto', p: 3 }}>
//       <Typography variant="h4" align="center" gutterBottom sx={{ fontWeight: 'bold', color: 'white', mb: 4 }}>
//         Payroll Management
//       </Typography>

//       <StyledPaper elevation={3} style={{ backgroundColor: "white", color: "black", padding: "16px", borderRadius: "8px" }}>
//         <Grid container spacing={3}>
//           <Grid item xs={12} md={6}>
//             <FormControl fullWidth>
//               <InputLabel id="employee-select-label"  sx={{ color: "red" }}>Select Employee</InputLabel>
//               <Select
//                 labelId="employee-select-label"
//                 value={selectedEmployee}
//                 onChange={(e) => setSelectedEmployee(e.target.value)}
//                 label="Select Employee"
//                 disabled={isLoading}


//                 sx={{
//                   backgroundColor: "white",
//                   color: "black",
//                   borderRadius: "4px",
//                   "& .MuiOutlinedInput-notchedOutline": {
//                     borderColor: "black",
//                   },
//                   "&:hover .MuiOutlinedInput-notchedOutline": {
//                     borderColor: "red",
//                   },
//                   "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
//                     borderColor: "green",
//                   },
//                 }}
//               >
//                 <MenuItem value=""><em style={{ color: "yellow" }}>Choose an Employee</em></MenuItem>
//                 {employees.map((employee) => (
//                   <MenuItem key={employee.id} value={employee.email} style={{ color: "#ffffff", backgroundColor: "#444" }}>
//                     {employee.name} - {employee.email}
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//           </Grid>
//           <Grid item xs={12} md={6}>



//           <TextField
//   label="Select Month"
//   type="month"
//   fullWidth
//   InputLabelProps={{ shrink: true, style: { color: "red" } }}
//   value={selectedDate}
//   onChange={(e) => {
//     const selected = e.target.value;
//     const currentDate = new Date();
//     const currentYearMonth = `${currentDate.getFullYear()}-${String(currentDate.getMonth() + 1).padStart(2, '0')}`;
    
//     // Only update if selected month is not in the future
//     if (selected <= currentYearMonth) {
//       setSelectedDate(selected);
//     }
//   }}
//   disabled={isLoading}
//   inputProps={{
//     max: `${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, '0')}`
//   }}
//   sx={{
//     backgroundColor: "white",
//     color: "black",
//     borderRadius: "4px",
//     "& .MuiOutlinedInput-root": {
//       "& fieldset": { borderColor: "black", color: "black" },
//       "&:hover fieldset": { borderColor: "black" },
//       "&.Mui-focused fieldset": { borderColor: "black" },
//     },
//     "& input": {
//       color: "black",
//     }
//   }}
// /> 
         

// {/* 


// <TextField
//               label="Select Month"
//               type="month"
//               fullWidth
//               InputLabelProps={{ shrink: true ,  style: { color: "red" }}}
//               value={selectedDate}
//               onChange={(e) => setSelectedDate(e.target.value)}
//               disabled={isLoading}


//               sx={{
//                 backgroundColor: "white",
//                 color: "black",
//                 borderRadius: "4px",
//                 "& .MuiOutlinedInput-root": {
//                   "& fieldset": { borderColor: "black" , color:"black"},
//                   "&:hover fieldset": { borderColor: "black" },
//                   "&.Mui-focused fieldset": { borderColor: "black" },
//                 },
//                 "& input": {
//                   color: "black", // Ensure selected value is visible (white)
//                 }
//               }}



//             />  */}



        
//           </Grid>
//         </Grid>
//       </StyledPaper>

//       {renderPayrollForm()}
//     </Box>
//   );
// };

// export default PayrollPage;







// import React, { forwardRef, useState, useEffect, useImperativeHandle } from "react";
// import { 
//   Box, 
//   Typography, 
//   TextField, 
//   Button, 
//   MenuItem, 
//   Select, 
//   FormControl, 
//   InputLabel, 
//   Paper, 
//   Divider, 
//   Grid, 
//   CircularProgress,
//   useTheme
// } from '@mui/material';
// import { styled } from '@mui/system';

// const StyledPaper = styled(Paper)(({ theme }) => ({
//   padding: theme.spacing(3),
//   margin: theme.spacing(2, 0),
//   borderRadius: theme.shape.borderRadius * 2,
//   boxShadow: theme.shadows[3],
// }));

// const StyledButton = styled(Button)(({ theme }) => ({
//   marginTop: theme.spacing(2),
//   padding: theme.spacing(1.5),
//   fontWeight: 'bold',
//   fontSize: '1rem',
// }));

// const PayrollPage = forwardRef(({ handleFieldChange, initialData, setIsDirty }, ref) => {
//   const theme = useTheme();
//   const [earnings, setEarnings] = useState([]);
//   const [deductions, setDeductions] = useState([]);
//   const [employees, setEmployees] = useState([]);
//   const [selectedEmployee, setSelectedEmployee] = useState(initialData?.selectedEmployee || "");
//   const [selectedDate, setSelectedDate] = useState(initialData?.selectedDate || "");
//   const [earningValues, setEarningValues] = useState(initialData?.earningValues || {});
//   const [deductionValues, setDeductionValues] = useState(initialData?.deductionValues || {});
//   const [existingPayroll, setExistingPayroll] = useState(null);
//   const [isPreview, setIsPreview] = useState(false);
//   const [isLoading, setIsLoading] = useState(false);
//   const [defaultCTCEarnings, setDefaultCTCEarnings] = useState([]);
//   const [defaultCTCDeductions, setDefaultCTCDeductions] = useState([]);
//   const[clicked , setclicked] = useState(false);

//   useEffect(() => {
//     fetchEmployees();
//     fetchCTCDetails();
//     console.log("i am checking ")

//     console.log(initialData.employee_id);
//   }, []);



//   useEffect(() => {
//     if (selectedEmployee && selectedDate) {
//       checkExistingPayroll();
//     } else {
//       setExistingPayroll(null);
//       setEarnings(defaultCTCEarnings);
//       setDeductions(defaultCTCDeductions);
//       setEarningValues(initialData?.earningValues || {});
//       setDeductionValues(initialData?.deductionValues || {});
//     }
//   }, [selectedEmployee, selectedDate]);

//   const fetchEmployees = async () => {
//     try {
//       const response = await fetch(`${process.env.REACT_APP_BACKEND_URL_HRM}/get-employees`);
//       const data = await response.json();
//       if (response.ok) {
//         setEmployees(data.employees);
//       } else {
//         alert(data.error);
//       }
//     } catch (error) {
//       console.error("Error fetching employees:", error);
//       alert("Failed to load employees.");
//     }
//   };

//   const checkExistingPayroll = async () => {
//     try {
//       setIsLoading(true);
//       const response = await fetch(`${process.env.REACT_APP_BACKEND_URL_HRM}/get-payroll`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({
//           email_id: selectedEmployee,
//           date: selectedDate,
//         }),
//       });

//       const data = await response.json();
//       if (response.ok && data.payroll_data) {
//         setExistingPayroll(data.payroll_data);
//         const payrollEarnings = Object.keys(data.payroll_data.earnings || {});
//         const payrollDeductions = Object.keys(data.payroll_data.deductions || {});
        
//         setEarnings(payrollEarnings);
//         setDeductions(payrollDeductions);
//         setEarningValues(data.payroll_data.earnings || {});
//         setDeductionValues(data.payroll_data.deductions || {});
        
//         // Update parent component with the loaded data
//         handleFieldChange("payrollDetails", "earningValues", data.payroll_data.earnings || {});
//         handleFieldChange("payrollDetails", "deductionValues", data.payroll_data.deductions || {});
//       } else {
//         setExistingPayroll(null);
//         setEarnings(defaultCTCEarnings);
//         setDeductions(defaultCTCDeductions);
//         setEarningValues(initialData?.earningValues || {});
//         setDeductionValues(initialData?.deductionValues || {});
//       }
//     } catch (error) {
//       console.error("Error checking existing payroll:", error);
//       setExistingPayroll(null);
//       setEarnings(defaultCTCEarnings);
//       setDeductions(defaultCTCDeductions);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const fetchCTCDetails = async () => {
//     try {
//       const response = await fetch(`${process.env.REACT_APP_BACKEND_URL_HRM}/get_ctc`);
//       const data = await response.json();
//       if (response.ok) {
//         setEarnings(data.earnings || []);
//         setDeductions(data.deductions || []);
//         setDefaultCTCEarnings(data.earnings || []);
//         setDefaultCTCDeductions(data.deductions || []);
//       } else {
//         alert(data.error);
//       }
//     } catch (error) {
//       console.error("Error fetching CTC details:", error);
//       alert("Failed to load CTC details.");
//     }
//   };

//   const handleEarningChange = (field, value) => {
//     const newValues = { ...earningValues, [field]: Number(value) };
//     setEarningValues(newValues);
//     handleFieldChange("payrollDetails", "earningValues", newValues);
//     setIsDirty(true);
//   };

//   const handleDeductionChange = (field, value) => {
//     const newValues = { ...deductionValues, [field]: Number(value) };
//     setDeductionValues(newValues);
//     handleFieldChange("payrollDetails", "deductionValues", newValues);
//     setIsDirty(true);
//   };

//   const handleEmployeeChange = (value) => {
//     setSelectedEmployee(value);
//     handleFieldChange("payrollDetails", "selectedEmployee", value);
//     setIsDirty(true);
//   };

//   const handleDateChange = (value) => {
//     setSelectedDate(value);
//     handleFieldChange("payrollDetails", "selectedDate", value);
//     setIsDirty(true);
//   };

//   const handlePreview = async () => {
//     if (!selectedEmployee || !selectedDate) {
//       alert("Please select an employee and date.");
//       return;
//     }
//     setclicked(true);

//     const payload = {
//       email_id: selectedEmployee,
//       date: selectedDate,
//       earnings: earningValues,
//       deductions: deductionValues,
//     };

//     try {
//       setIsLoading(true);
//       const response = await fetch(`${process.env.REACT_APP_BACKEND_URL_HRM}/preview-payroll`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify(payload),
//       });

//       const data = await response.json();
//       if (response.ok) {
//         setExistingPayroll(data);
//         setIsPreview(true);
//       } else {
//         alert("Error: " + data.error);
//       }
//     } catch (error) {
//       console.error("Error previewing payroll:", error);
//       alert("Failed to preview payroll.");
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleSubmit = async () => {

//     if (!clicked) {
//     alert("please preview the payslip before generation")
//       return "PREVIEW_REQUIRED";
//     }

//     if (!selectedEmployee || !selectedDate) {
//       alert("Please select an employee and date.");
//       return false;
//     }

//     const payload = {
//       email_id: selectedEmployee,
//       selected_month: selectedDate,
//       earnings: earningValues,
//       deductions: deductionValues,
//       total_earnings: existingPayroll?.total_earnings || 0,
//       total_deductions: existingPayroll?.total_deductions || 0,
//       total_salary: existingPayroll?.total_salary || 0,
//       leave_summary: existingPayroll?.leave_summary || {},
//       total_leave_days: existingPayroll?.total_leave_days || 0,
//       actual_emergency_leave: existingPayroll?.actual_emergency_leave || 0,
//       actual_planned_leave: existingPayroll?.actual_planned_leave || 0,
//       subtracted_los_emergency_leave: existingPayroll?.subtracted_los_emergency_leave || 0,
//       subtracted_los_planned_leave: existingPayroll?.subtracted_los_planned_leave || 0,
//       one_day_salary: existingPayroll?.one_day_salary || 0,
//       LOSP: existingPayroll?.LOSP || 0,
//       LOSE: existingPayroll?.LOSE || 0,
//       total_los: existingPayroll?.total_los || 0,
//       LOP_DAYS: existingPayroll?.LOP_DAYS || 0,
//       actual_working_days: existingPayroll?.actual_working_days || 0,
//       num_days: existingPayroll?.num_days || 0, 
//     };

//     try {
//       setIsLoading(true);
//       const response = await fetch(`${process.env.REACT_APP_BACKEND_URL_HRM}/store-payroll`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify(payload),
//       });

//       const data = await response.json();
//       if (response.ok) {
//         alert("Payroll data saved successfully!");
//         setIsPreview(false);
//         checkExistingPayroll();
//         return true;
//       } else {
//         alert("Error: " + data.error);
//         return false;
//       }
//     } catch (error) {
//       console.error("Error submitting payroll:", error);
//       alert("Failed to submit payroll.");
//       return false;
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   useImperativeHandle(ref, () => ({
//     handleSubmit,
//   }));

//   const renderPayrollDetails = () => {
//     if (!existingPayroll) return null;

//     return (
//       <StyledPaper elevation={3} style={{backgroundColor:"white", color:"black"}}>
//         <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', color: 'primary.main' }}>
//           Payroll Details
//         </Typography>
//         <Divider sx={{ my: 2 }} />
        
//         <Grid container spacing={3}>
//           <Grid item xs={12} md={6}>
//             <Typography variant="body1"><strong>Number of Days Paid:</strong> {existingPayroll.actual_working_days}</Typography>
//             <Typography variant="body1"><strong>Total days in month:</strong> {existingPayroll.num_days}</Typography>
//             <Typography variant="body1"><strong>LOP Days:</strong> {existingPayroll.LOP_DAYS}</Typography>
//             <Typography variant="body1"><strong>Total Leaves Taken:</strong> {existingPayroll.total_leave_days}</Typography>
//             <Typography variant="body1"><strong>Emergency Leaves Taken:</strong> {existingPayroll.leave_summary.EMERGENCY}</Typography>
//             <Typography variant="body1"><strong>Planned Leaves Taken:</strong> {existingPayroll.leave_summary.PLANNED}</Typography>
//           </Grid>
//           <Grid item xs={12} md={6}>
//             <Typography variant="body1"><strong>Leave Opening (Emergency):</strong> {existingPayroll.actual_emergency_leave}</Typography>
//             <Typography variant="body1"><strong>Leave Opening (Planned):</strong> {existingPayroll.actual_planned_leave}</Typography>
//             <Typography variant="body1"><strong>Leave Closing (Emergency):</strong> {existingPayroll.subtracted_los_emergency_leave}</Typography>
//             <Typography variant="body1"><strong>Leave Closing (Planned):</strong> {existingPayroll.subtracted_los_planned_leave}</Typography>
//           </Grid>
//         </Grid>
        
//         <Box sx={{ mt: 3, p: 2, backgroundColor: '#f5f5f5', borderRadius: 1 }}>
//           <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
//             Net Salary: ₹{existingPayroll.total_salary}
//           </Typography>
//         </Box>
//       </StyledPaper>
//     );
//   };

//   const renderPayrollForm = () => {
//     if (isPreview && existingPayroll) {
//       return (
//         <StyledPaper elevation={3} style={{backgroundColor:"white", color:"black"}}>
//           <Typography variant="h5" align="center" gutterBottom sx={{ fontWeight: 'bold', color: 'primary.main' }}>
//             Payroll Preview
//           </Typography>
          
//           {renderPayrollDetails()}

//           <Grid container spacing={3} sx={{ mt: 2 }}>
//             <Grid item xs={12} md={6}>
//               <Typography variant="h6" gutterBottom>Earnings</Typography>
//               {Object.entries(existingPayroll.earnings || {}).map(([key, value]) => (
//                 <Box key={key} display="flex" justifyContent="space-between" mb={1}>
//                   <Typography>{key}:</Typography>
//                   <Typography>₹{value}</Typography>
//                 </Box>
//               ))}
//               <Divider sx={{ my: 1 }} />
//               <Box display="flex" justifyContent="space-between" sx={{ fontWeight: 'bold' }}>
//                 <Typography>Total Earnings:</Typography>
//                 <Typography>₹{existingPayroll.total_earnings}</Typography>
//               </Box>
//             </Grid>

//             <Grid item xs={12} md={6}>
//               <Typography variant="h6" gutterBottom>Deductions</Typography>
//               {Object.entries(existingPayroll.deductions || {}).map(([key, value]) => (
//                 <Box key={key} display="flex" justifyContent="space-between" mb={1}>
//                   <Typography>{key}:</Typography>
//                   <Typography>₹{value}</Typography>
//                 </Box>
//               ))}
//               <Divider sx={{ my: 1 }} />
//               <Box display="flex" justifyContent="space-between" sx={{ fontWeight: 'bold' }}>
//                 <Typography>Total Deductions:</Typography>
//                 <Typography>₹{existingPayroll.total_deductions}</Typography>
//               </Box>
//             </Grid>
//           </Grid>

//           <Box display="flex" justifyContent="space-between" mt={4}>
//             <Button
//               onClick={() => setIsPreview(false)}
//               variant="outlined"
//               color="secondary"
//               sx={{ width: '48%' }}
//             >
//               Cancel
//             </Button>
//             <Button
//               onClick={async () => {
//                 const success = await handleSubmit();
//                 if (success) {
//                   setIsPreview(false);
//                 }
//               }}
//               variant="contained"
//               color="primary"
//               sx={{ width: '48%' }}
//               disabled={isLoading}
//             >
//               {isLoading ? <CircularProgress size={24} /> : 'Generate Payslip'}
//             </Button>
//           </Box>
//         </StyledPaper>
//       );
//     }

//     return (
//       <>
//         {existingPayroll && renderPayrollDetails()}

//         <StyledPaper elevation={3} style={{ backgroundColor: "white", color: "black", padding: "16px", borderRadius: "8px" }}>
//           <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', color: "black" }}>
//             Earnings
//           </Typography>
//           {earnings.map((field, index) => (
//             <TextField
//               key={index}
//               label={field}
//               type="number"
//               variant="outlined"
//               fullWidth
//               margin="normal"
//               value={earningValues[field] || ""}
//               onChange={(e) => handleEarningChange(field, e.target.value)}
//               InputProps={{
//                 startAdornment: <Typography sx={{ mr: 1, color: "black" }}>₹</Typography>,
//                 style: { backgroundColor: "white", color: "black", borderRadius: "4px" }
//               }}
//               InputLabelProps={{
//                 style: { color: "red" }
//               }}
//               sx={{
//                 "& .MuiOutlinedInput-root": {
//                   "& fieldset": { borderColor: "#555" },
//                   "&:hover fieldset": { borderColor: "#777" },
//                   "&.Mui-focused fieldset": { borderColor: "#ffffff" },
//                 },
//               }}
//             />
//           ))}
//         </StyledPaper>

//         <StyledPaper elevation={3} style={{ backgroundColor: "white", color: "black", padding: "16px", borderRadius: "8px" }}>
//           <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', color: "black" }}>
//             Deductions
//           </Typography>
//           {deductions
//           .filter(field => isPreview || field !== "LOP")
//             .map((field, index) => (
//               <TextField
//                 key={index}
//                 label={field}
//                 type="number"
//                 variant="outlined"
//                 fullWidth
//                 margin="normal"
//                 value={deductionValues[field] || ""}
//                 onChange={(e) => handleDeductionChange(field, e.target.value)}
//                 InputProps={{
//                   startAdornment: <Typography sx={{ mr: 1, color: "black" }}>₹</Typography>,
//                   style: { backgroundColor: "white", color: "black", borderRadius: "4px" }
//                 }}
//                 InputLabelProps={{
//                   style: { color: "red" }
//                 }}
//                 sx={{
//                   "& .MuiOutlinedInput-root": {
//                     "& fieldset": { borderColor: "#555" },
//                     "&:hover fieldset": { borderColor: "#777" },
//                     "&.Mui-focused fieldset": { borderColor: "#ffffff" },
//                   },
//                 }}
//               />
//             ))}
//         </StyledPaper>

//         <StyledButton
//           variant="contained"
//           color="primary"
//           fullWidth
//           onClick={handlePreview}
//           disabled={isLoading || !selectedEmployee || !selectedDate}
//           elevation={3} style={{ backgroundColor: "white", color: "black", padding: "16px", borderRadius: "8px" }}
//         >
//           {isLoading ? <CircularProgress size={24} color="inherit" /> : 'Preview Payslip'}
//         </StyledButton>
//       </>
//     );
//   };

//   return (
//     <Box sx={{ maxWidth: 900, mx: 'auto', p: 3 }}>
//       <Typography variant="h4" align="center" gutterBottom sx={{ fontWeight: 'bold', color: 'white', mb: 4 }}>
//         Payroll Management
//       </Typography>

//       <StyledPaper elevation={3} style={{ backgroundColor: "white", color: "black", padding: "16px", borderRadius: "8px" }}>
//         <Grid container spacing={3}>
//           <Grid item xs={12} md={6}>
//             <FormControl fullWidth>
//               <InputLabel id="employee-select-label" sx={{ color: "red" }}>Select Employee</InputLabel>
//               <Select
//                 labelId="employee-select-label"
//                 value={selectedEmployee}
//                 onChange={(e) => handleEmployeeChange(e.target.value)}
//                 label="Select Employee"
//                 disabled={isLoading}
//                 sx={{
//                   backgroundColor: "white",
//                   color: "black",
//                   borderRadius: "4px",
//                   "& .MuiOutlinedInput-notchedOutline": {
//                     borderColor: "black",
//                   },
//                   "&:hover .MuiOutlinedInput-notchedOutline": {
//                     borderColor: "red",
//                   },
//                   "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
//                     borderColor: "green",
//                   },
//                 }}
//               >
//                 <MenuItem value=""><em style={{ color: "yellow" }}>Choose an Employee</em></MenuItem>
//                 {employees.map((employee) => (
//                   <MenuItem key={employee.id} value={employee.email} style={{ color: "#ffffff", backgroundColor: "#444" }}>
//                     {employee.name} - {employee.email}
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//           </Grid>
//           <Grid item xs={12} md={6}>
//             <TextField
//               label="Select Month"
//               type="month"
//               fullWidth
//               InputLabelProps={{ shrink: true, style: { color: "red" } }}
//               value={selectedDate}
//               onChange={(e) => {
//                 const selected = e.target.value;
//                 const currentDate = new Date();
//                 const currentYearMonth = `${currentDate.getFullYear()}-${String(currentDate.getMonth() + 1).padStart(2, '0')}`;
                
//                 if (selected <= currentYearMonth) {
//                   handleDateChange(selected);
//                 }
//               }}
//               disabled={isLoading}
//               inputProps={{
//                 max: `${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, '0')}`
//               }}
//               sx={{
//                 backgroundColor: "white",
//                 color: "black",
//                 borderRadius: "4px",
//                 "& .MuiOutlinedInput-root": {
//                   "& fieldset": { borderColor: "black", color: "black" },
//                   "&:hover fieldset": { borderColor: "black" },
//                   "&.Mui-focused fieldset": { borderColor: "black" },
//                 },
//                 "& input": {
//                   color: "black",
//                 }
//               }}
//             /> 
//           </Grid>
//         </Grid>
//       </StyledPaper>

//       {renderPayrollForm()}
//     </Box>
//   );
// });

// export default PayrollPage;
import React, { forwardRef, useState, useEffect, useImperativeHandle } from "react";
import {
  Box,
  Grid,
  TextField,
  Button,
  Paper,
  Typography,
  Divider,
  CircularProgress,
} from "@mui/material";
import { styled } from "@mui/system";
import { useTheme } from "@mui/material";
import { tokens } from "../../theme";

const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(4),
  margin: theme.spacing(3, 0),
  borderRadius: theme.shape.borderRadius * 2,
  backgroundColor: theme.palette.mode === "dark" ? "#1F2A40" : "#F9FAFB",
  boxShadow: theme.shadows[5],
}));

const StyledButton = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing(3),
  padding: theme.spacing(1.5),
  fontWeight: "bold",
  fontSize: "1rem",
  width: "100%",
  textTransform: "uppercase",
}));

const StyledTextField = styled(TextField)(({ theme }) => ({
  "& .MuiInputBase-root": {
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.shape.borderRadius,
  },
}));

const SectionTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.mode === "dark" ? theme.palette.primary.light : theme.palette.primary.dark,
  fontWeight: 600,
  marginBottom: theme.spacing(2),
}));

const PayrollPage = forwardRef(
  ({ initialData = {}, handleFieldChange, setIsDirty }, ref) => {
    const [email, setEmail] = useState(
      initialData.corporate_email_id || initialData.employee_id || ""
    );
    const [startDate, setStartDate] = useState("");
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [endDate, setEndDate] = useState("");
    const [earnings, setEarnings] = useState({});
    const [deductions, setDeductions] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [errors, setErrors] = useState({});

    const [ctcCategories, setCtcCategories] = useState({
      earnings: [],
      deductions: [],
    });
    const accessToken = JSON.parse(localStorage.getItem('emsUser'))?.user?.stsTokenManager?.accessToken;
    // Exposing the handleSubmit function via ref to the parent
    useImperativeHandle(ref, () => ({
      handleSubmit,
    }));

    useEffect(() => {
      setEmail(
        initialData.corporate_email_id || initialData.employee_id || ""
      );
    }, [initialData.corporate_email_id, initialData.employee_id]);

    useEffect(() => {
      const fetchCtcCategories = async () => {
        try {
          const response = await fetch(`${process.env.REACT_APP_BACKEND_URL_HRM}/get_ctc`, {
            method: 'GET',
            headers: {
              'Authorization': `Bearer ${accessToken}`
            }
          });
          const data = await response.json();
          if (response.ok) {
            setCtcCategories(data);
            const initialEarnings = {};
            data.earnings.forEach((item) => {
              initialEarnings[item] = {
                amount_per_anum: 0,
                amount_per_month: 0,
              };
            });
            const initialDeductions = {};
            data.deductions.forEach((item) => {
              initialDeductions[item] = {
                amount_per_anum: 0,
                amount_per_month: 0,
              };
            });
            setEarnings(initialEarnings);
            setDeductions(initialDeductions);
          } else {
            console.error("Failed to fetch CTC categories:", data.error);
          }
        } catch (error) {
          console.error("Error fetching CTC categories:", error);
        }
      };

      fetchCtcCategories();
    }, []);

    const validatePayrollForm = () => {
      const newErrors = {};

      if (!email) newErrors.email = "Email is required";
      if (!startDate) newErrors.startDate = "Start Date is required";
      if (!endDate) newErrors.endDate = "End Date is required";

      if (!earnings || Object.keys(earnings).length === 0)
        newErrors.earnings = "Earnings are required";

      if (!deductions || Object.keys(deductions).length === 0)
        newErrors.deductions = "Deductions are required";

      return newErrors;
    };

    const handleSubmit = async (corporateEmail) => {
      const validationErrors = validatePayrollForm();

        if (Object.keys(validationErrors).length > 0) {
          setErrors(validationErrors);
          return false;
        }

      setErrors({});
      setIsLoading(true);
    
      try {
        const total_earnings = Object.values(earnings).reduce(
          (acc, val) => acc + (val.amount_per_anum || 0),
          0
        );
        const total_deductions = Object.values(deductions).reduce(
          (acc, val) => acc + (val.amount_per_anum || 0),
          0
        );
        const total_salary = total_earnings - total_deductions;
    
        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL_HRM}/store-payroll-yearly`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            email_id: corporateEmail,
            start_date: startDate,
            end_date: endDate,
            earnings,
            deductions,
            total_earnings,
            total_deductions,
            total_salary,
          }),
        });
    
        const data = await response.json();
    
        if (response.ok) {
          alert("Payroll saved successfully!");
          return true; // Indicate success
        } else {
          alert(data.error || "Failed to save payroll.");
          return false; // Indicate failure
        }
      } catch (error) {
        console.error("Error saving payroll:", error);
        alert("An error occurred while saving payroll. Please try again.");
        return false; // Indicate failure
      } finally {
        setIsLoading(false);
      }
    };


    useImperativeHandle(ref, () => ({
        save: async (corporateEmail) => {
          return await handleSubmit(corporateEmail);
        },
        validate: () => {
          const errors = validatePayrollForm(); 
          setErrors(errors); 
          return Object.keys(errors).length === 0; 
        },
      }));

    const renderEarnings = () =>
      ctcCategories.earnings.map((key) => (
        <Grid container spacing={2} key={key} sx={{ mb: 2 }}>
          <Grid item xs={12} sm={4}>
            <Typography>{key}</Typography>
          </Grid>
          <Grid item xs={12} sm={4}>
            <StyledTextField
              label="Amount Per Annum"
              type="number"
              value={earnings[key]?.amount_per_anum || 0}
              onChange={(e) =>
                setEarnings({
                  ...earnings,
                  [key]: {
                    ...earnings[key],
                    amount_per_anum: Number(e.target.value),
                    amount_per_month:Math.round(Number(e.target.value) / 12),
                  },
                })
              }
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <StyledTextField
              label="Amount Per Month"
              type="number"
              value={earnings[key]?.amount_per_month || 0}
              disabled
              fullWidth
            />
          </Grid>
        </Grid>
      ));

      const renderDeductions = () =>
        ctcCategories.deductions
          .filter((key) => key !== "LOP") // Filter out "LOP"
          .map((key) => (
            <Grid container spacing={2} key={key} sx={{ mb: 2 }}>
              <Grid item xs={12} sm={4}>
                <Typography color={colors.grey[100]}>{key}</Typography>
              </Grid>
              <Grid item xs={12} sm={4}>
                <StyledTextField
                  label="Amount Per Annum"
                  type="number"
                  value={deductions[key]?.amount_per_anum || 0}
                  onChange={(e) =>
                    setDeductions({
                      ...deductions,
                      [key]: {
                        ...deductions[key],
                        amount_per_anum: Number(e.target.value),
                        amount_per_month: Math.round(Number(e.target.value) / 12),
                      },
                    })
                  }
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <StyledTextField
                  label="Amount Per Month"
                  type="number"
                  value={deductions[key]?.amount_per_month || 0}
                  disabled
                  fullWidth
                />
              </Grid>
            </Grid>
          ));

    return (
      <Box m={2}>
        <StyledPaper>
          <Typography variant="h5" gutterBottom color={colors.greenAccent[500]}>
            Payroll Management
          </Typography>
          <Divider  sx={{ backgroundColor: colors.grey[700] }}/>
          <Grid container spacing={2} mt={2}>
            <Grid item xs={12} sm={4}>
              <StyledTextField
                label="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                fullWidth
                disabled
                error={!!errors.email}
                helperText={errors.email}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <StyledTextField
                label="Start Date"
                type="date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                InputLabelProps={{
                  shrink: true,
                }}
                fullWidth
                error={!!errors.startDate}
                helperText={errors.startDate}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <StyledTextField
                label="End Date"
                type="date"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
                InputLabelProps={{
                  shrink: true,
                }}
                fullWidth
                error={!!errors.endDate}
                helperText={errors.endDate}
              />
            </Grid>
          </Grid>

          {isLoading && (
            <Box display="flex" justifyContent="center" mt={3}>
              <CircularProgress />
            </Box>
          )}

          <Box mt={4}>
            <SectionTitle variant="h6">Earnings</SectionTitle>
            {renderEarnings()}
          </Box>
          <Box mt={4}>
            <SectionTitle variant="h6">Deductions</SectionTitle>
            {errors.earnings && (
              <Typography color="error" variant="body2" mt={1}>
                {errors.earnings}
              </Typography>
            )}

            {renderEarnings()}

            {errors.deductions && (
              <Typography color="error" variant="body2" mt={1}>
                {errors.deductions}
              </Typography>
            )}
            {renderDeductions()}
          </Box>
          {/* <StyledButton
            variant="contained"
            color="primary"
            onClick={handleSubmit}
            disabled={isLoading}
          >
            {isLoading ? <CircularProgress size={24} /> : "Save Payroll"}
          </StyledButton> */}
        </StyledPaper>
      </Box>
    );
  }
);

export default PayrollPage;